/**
 * Custom hook to access theme state and functionality throughout the application
 */
import { useContext } from "react";

import { ThemeContext, ThemeContextType } from "../context/ThemeProvider";

/**
 * useTheme - Hook for accessing the theme functionality
 * @returns {ThemeContextType} Theme state and control methods
 */
export const useTheme = (): ThemeContextType => {
  const context = useContext<ThemeContextType | undefined>(ThemeContext);

  if (!context) {
    throw new Error(
      "useTheme must be used within a ThemeProvider"
    );
  }

  return context;
};

export default useTheme; 
